import {UserModel} from '@/Pages/Admin/Modules/Models/ManageAccount/UserModel';

export class AccountUserModel {
    public id: number;
    public uuid: string;
    public user_id: number;
    public account_id: number;
    public is_invitation: number;
    public invited_by_id: number;
    public invited_date: string;
    public last_email_sent_date: string;
    public is_invitation_complete: number;
    public is_active: number;
    public activated_date: string;
    public activated_reason: string;
    public user: UserModel = new UserModel({});
    public created_at: string;
    public updated_at: string;

    constructor(obj: any) {
        this.id = obj.id ? obj.id : 0;
        this.uuid = obj.uuid ? obj.uuid : '';
        this.user_id = obj.user_id ? obj.user_id : 0;
        this.account_id = obj.account_id ? obj.account_id : 0;
        this.is_invitation = obj.is_invitation ? obj.is_invitation : 0;
        this.invited_by_id = obj.invited_by_id ? obj.invited_by_id : 0;
        this.invited_date = obj.invited_date ? obj.invited_date : '';
        this.last_email_sent_date = obj.last_email_sent_date ? obj.last_email_sent_date : '';
        this.is_invitation_complete = obj.is_invitation_complete ? obj.is_invitation_complete : 0;
        this.is_active = obj.is_active ? obj.is_active : 0;
        this.activated_date = obj.activated_date ? obj.activated_date : '';
        this.activated_reason = obj.activated_reason ? obj.activated_reason : '';
        this.user = obj.activated_reason ? obj.activated_reason : new UserModel({});
        this.created_at = obj.created_at ? obj.created_at : '';
        this.updated_at = obj.updated_at ? obj.updated_at : '';
    }
}
